import state from './rpiclient.state'
import mutations from './rpiclient.mutations'
import actions from './rpiclient.actions'

export default {
  state,
  mutations,
  actions
}
